import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/home/home.tsx';
import PageNotFound from './components/pagenotfound/pagenotfound.tsx';
import NavBar from './components/navbar/navbar.tsx';
import MobileNavbar from './components/navbar/mobilenavbar.tsx';
import ProjectPage from "./components/projects/project_page.tsx";
import VoicePilot from './components/specific_projects/voicepilot.tsx';
import PetConnect from './components/specific_projects/petconnect.tsx';
import SparkSocial from './components/specific_projects/sparksocial.tsx';
import NanoGurus from "./components/specific_projects/nanogurus.tsx";
import CenterStage from './components/specific_projects/centerstage.tsx';
import PowerPlay from './components/specific_projects/powerplay.tsx';
import EngineeringProject from './components/specific_projects/engineering_project.tsx';
import { AuthProvider } from '../src/components/signin/authcontext.jsx'; // Adjust path based on your project
import ProtectedRoute from './components/general/protectedroutes.jsx';
import Dashboard from './components/dashboard/dashboard.jsx';
import SignIn from './components/signin/signin.jsx';
function App() {
  let WebPages = [
    ['Home', '/'],
    ['Projects', '/projects'],
  ];
  const ptop = {
    "paddingTop": "6em"
  }
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <div className="hidden sm:hidden md:block">
            <NavBar WebPages={WebPages} />
          </div>
          <div className="block sm:block md:hidden">
            <MobileNavbar WebPages={WebPages} />
          </div>
          <div style={ptop} className="bg-gray-300 min-h-screen h-fit ">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<ProjectPage />} />
              <Route path="/projects/voicepilot" element={<VoicePilot />} />
              <Route path="/projects/petconnect" element={<PetConnect />} />
              <Route path="/projects/fbla" element={<SparkSocial />} />
              <Route path="/projects/nanogurus" element={<NanoGurus />} />
              <Route path="/projects/ftccenterstage" element={<CenterStage />} />
              <Route path="/projects/ftcpowerplay" element={<PowerPlay />} />
              <Route path="/projects/engineering/:slug" element={<EngineeringProject />} />
              <Route path="/signin" element={<SignIn/>} />
              <Route path="" element={<ProtectedRoute />} >
                    <Route exact path="/dashboard" element={<Dashboard />} />
              </Route>
              <Route
                path="*"
                element={<PageNotFound />}
              />
              {/* Add other routes here */}
            </Routes>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
